/**
 * Libellés du Volet communs aux deux inspecteurs (document et site), au même
 * titre que ceux de la Carte info : un seul endroit pour que le mot ne change
 * pas d'un éditeur à l'autre.
 */
export const ACCORDION_PANEL_GROUP = 'Volet';

export const ACCORDION_PANEL_LABELS = {
  panelColor: 'Couleur du volet',
  answerBackground: 'Fond de la réponse',
};
